// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMFiltersHeader-module__font-s-10___M10k1 {
  font-size: 10px !important;
}

.CGMFiltersHeader-module__font-s-12___X5Qnc {
  font-size: 12px !important;
}

.CGMFiltersHeader-module__font-s-13___o4s9u {
  font-size: 13px !important;
}

.CGMFiltersHeader-module__font-s-14___CK7fe {
  font-size: 14px !important;
}

.CGMFiltersHeader-module__font-s-15___m9Dbt {
  font-size: 15px !important;
}

.CGMFiltersHeader-module__font-s-16___kL7Sl {
  font-size: 16px !important;
}

.CGMFiltersHeader-module__font-s-18___KLXE6 {
  font-size: 18px !important;
}

.CGMFiltersHeader-module__font-s-20___UA85s {
  font-size: 20px !important;
}

.CGMFiltersHeader-module__font-s-22___Zjf1L {
  font-size: 22px !important;
}

.CGMFiltersHeader-module__font-s-28___v7FLt {
  font-size: 28px !important;
}

.CGMFiltersHeader-module__font-w-400___C1M5r {
  font-weight: 400 !important;
}

.CGMFiltersHeader-module__font-w-500___Q9RdV {
  font-weight: 500 !important;
}

.CGMFiltersHeader-module__font-w-600___oCl83 {
  font-weight: 600 !important;
}

.CGMFiltersHeader-module__font-w-700___W5Dmx {
  font-weight: 700 !important;
}

.CGMFiltersHeader-module__p-5___SXQJC {
  padding: 5px !important;
}

.CGMFiltersHeader-module__p-12___Af8QT {
  padding: 12px !important;
}

.CGMFiltersHeader-module__p-16___zzxAu {
  padding: 16px !important;
}

.CGMFiltersHeader-module__p-30___iq95j {
  padding: 30px !important;
}

.CGMFiltersHeader-module__p-b-0___Dda6_ {
  padding-bottom: 0 !important;
}

.CGMFiltersHeader-module__p-b-5____hz_n {
  padding-bottom: 5px !important;
}

.CGMFiltersHeader-module__p-b-10___QAGiD {
  padding-bottom: 10px !important;
}

.CGMFiltersHeader-module__p-b-12___icjoo {
  padding-bottom: 12px !important;
}

.CGMFiltersHeader-module__p-b-16___ytq44 {
  padding-bottom: 16px !important;
}

.CGMFiltersHeader-module__p-b-18___R_nhN {
  padding-bottom: 18px !important;
}

.CGMFiltersHeader-module__p-b-20___E7b68 {
  padding-bottom: 20px !important;
}

.CGMFiltersHeader-module__p-b-25___vsYnd {
  padding-bottom: 25px !important;
}

.CGMFiltersHeader-module__p-b-30___VEcfO {
  padding-bottom: 30px !important;
}

.CGMFiltersHeader-module__p-b-50___fFTBq {
  padding-bottom: 50px !important;
}

.CGMFiltersHeader-module__p-t-0___mA21f {
  padding-top: 0 !important;
}

.CGMFiltersHeader-module__p-t-12___QyOdS {
  padding-top: 12px !important;
}

.CGMFiltersHeader-module__p-t-16___q0ian {
  padding-top: 16px !important;
}

.CGMFiltersHeader-module__p-t-18___VeYnp {
  padding-top: 18px !important;
}

.CGMFiltersHeader-module__p-t-20___LEsf4 {
  padding-top: 20px !important;
}

.CGMFiltersHeader-module__p-t-30___eAHGV {
  padding-top: 30px !important;
}

.CGMFiltersHeader-module__p-t-40___SbmRY {
  padding-top: 40px !important;
}

.CGMFiltersHeader-module__p-t-50___wfkYx {
  padding-top: 50px !important;
}

.CGMFiltersHeader-module__p-l-20___cx7pa {
  padding-left: 20px !important;
}

.CGMFiltersHeader-module__p-l-30___piVK0 {
  padding-left: 30px !important;
}

.CGMFiltersHeader-module__p-l-40___R7Xse {
  padding-left: 40px !important;
}

.CGMFiltersHeader-module__p-r-16___rknlF {
  padding-right: 16px !important;
}

.CGMFiltersHeader-module__p-r-20___FWOww {
  padding-right: 20px !important;
}

.CGMFiltersHeader-module__p-r-30___Z3raj {
  padding-right: 30px !important;
}

.CGMFiltersHeader-module__p-r-50___a_AF4 {
  padding-right: 50px !important;
}

.CGMFiltersHeader-module__p-r-60___B_XIp {
  padding-right: 60px !important;
}

.CGMFiltersHeader-module__m-b-1___PC3T8 {
  margin-bottom: 1px !important;
}

.CGMFiltersHeader-module__m-b-2___o6GIQ {
  margin-bottom: 2px !important;
}

.CGMFiltersHeader-module__m-b-6___BTEvW {
  margin-bottom: 6px !important;
}

.CGMFiltersHeader-module__m-b-8___VYOmk {
  margin-bottom: 8px !important;
}

.CGMFiltersHeader-module__m-b-10___z6uu2 {
  margin-bottom: 10px !important;
}

.CGMFiltersHeader-module__m-b-14___k0Cz0 {
  margin-bottom: 14px !important;
}

.CGMFiltersHeader-module__m-b-16___bNmkN {
  margin-bottom: 16px !important;
}

.CGMFiltersHeader-module__m-b-20____GsRc {
  margin-bottom: 20px !important;
}

.CGMFiltersHeader-module__m-b-22___ctpkE {
  margin-bottom: 22px !important;
}

.CGMFiltersHeader-module__m-b-24___hMeKW {
  margin-bottom: 24px !important;
}

.CGMFiltersHeader-module__m-b-30___ONZ8D {
  margin-bottom: 30px !important;
}

.CGMFiltersHeader-module__m-b-32___EcbuU {
  margin-bottom: 32px !important;
}

.CGMFiltersHeader-module__m-b-40____miR2 {
  margin-bottom: 40px !important;
}

.CGMFiltersHeader-module__m-t-2___vzpUi {
  margin-top: 2px !important;
}

.CGMFiltersHeader-module__m-t-3___Fdoct {
  margin-top: 3px !important;
}

.CGMFiltersHeader-module__m-t-4___c3VIz {
  margin-top: 4px !important;
}

.CGMFiltersHeader-module__m-t-5___XYoH0 {
  margin-top: 5px !important;
}

.CGMFiltersHeader-module__m-t-8___XLiu0 {
  margin-top: 8px !important;
}

.CGMFiltersHeader-module__m-t-10___IMq87 {
  margin-top: 10px !important;
}

.CGMFiltersHeader-module__m-t-15___X0Cfs {
  margin-top: 15px !important;
}

.CGMFiltersHeader-module__m-t-16___qlOzG {
  margin-top: 16px !important;
}

.CGMFiltersHeader-module__m-t-20___iqJ4g {
  margin-top: 20px !important;
}

.CGMFiltersHeader-module__m-t-22___Scsx_ {
  margin-top: 22px !important;
}

.CGMFiltersHeader-module__m-t-30___oG2x0 {
  margin-top: 30px !important;
}

.CGMFiltersHeader-module__m-t-32___olsJr {
  margin-top: 32px !important;
}

.CGMFiltersHeader-module__m-l-auto___Lwp5A {
  margin-left: auto !important;
}

.CGMFiltersHeader-module__m-l-4___y5geV {
  margin-left: 4px !important;
}

.CGMFiltersHeader-module__m-l-5___wrznR {
  margin-left: 5px !important;
}

.CGMFiltersHeader-module__m-l-6___X5UYr {
  margin-left: 6px !important;
}

.CGMFiltersHeader-module__m-l-8___QcYU3 {
  margin-left: 8px !important;
}

.CGMFiltersHeader-module__m-l-10___WMZDd {
  margin-left: 10px !important;
}

.CGMFiltersHeader-module__m-l-16___eUSyn {
  margin-left: 16px !important;
}

.CGMFiltersHeader-module__m-l-20___jARj0 {
  margin-left: 20px !important;
}

.CGMFiltersHeader-module__m-l-24___E9e2h {
  margin-left: 24px !important;
}

.CGMFiltersHeader-module__m-l-30___wolvo {
  margin-left: 30px !important;
}

.CGMFiltersHeader-module__m-l-35___uqnXB {
  margin-left: 35px !important;
}

.CGMFiltersHeader-module__m-l-40___pnX5L {
  margin-left: 40px !important;
}

.CGMFiltersHeader-module__m-r-8___GZxUG {
  margin-right: 8px !important;
}

.CGMFiltersHeader-module__m-r-10___Invz4 {
  margin-right: 10px !important;
}

.CGMFiltersHeader-module__m-r-16___XBqcX {
  margin-right: 16px !important;
}

.CGMFiltersHeader-module__m-r-20___prt6Q {
  margin-right: 20px !important;
}

.CGMFiltersHeader-module__m-r-24___zsRSl {
  margin-right: 24px !important;
}

.CGMFiltersHeader-module__m-r-30___YKnep {
  margin-right: 30px !important;
}

.CGMFiltersHeader-module__m-r-40___C2qFk {
  margin-right: 40px !important;
}

.CGMFiltersHeader-module__border-r-3___JTH1P {
  border-radius: 3px !important;
}

.CGMFiltersHeader-module__border-r-4___XlA6D {
  border-radius: 4px !important;
}

.CGMFiltersHeader-module__border-r-6___MRXMt {
  border-radius: 6px !important;
}

.CGMFiltersHeader-module__border-r-10___tNNm2 {
  border-radius: 10px !important;
}

.CGMFiltersHeader-module__border-r-12___BoM2q {
  border-radius: 12px !important;
}

.CGMFiltersHeader-module__border-r-16___cggux {
  border-radius: 16px !important;
}

.CGMFiltersHeader-module__border-r-50___pmeE2 {
  border-radius: 50% !important;
}

.CGMFiltersHeader-module__primary-border___yRhi3 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMFiltersHeader-module__primary-border-b___bt_te {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMFiltersHeader-module__primary-border-t___VFQfw {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMFiltersHeader-module__primary-border-l___V4eM2 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMFiltersHeader-module__primary-border-r___kdkNS {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMFiltersHeader-module__secondary-border___bGNkZ {
  border: 1px solid #637768;
}

.CGMFiltersHeader-module__secondary-border-b___cLvzm {
  border-bottom: 1px solid #637768;
}

.CGMFiltersHeader-module__secondary-border-t___f5K84 {
  border-top: 1px solid #637768;
}

.CGMFiltersHeader-module__secondary-border-l___bFL0V {
  border-left: 1px solid #637768;
}

.CGMFiltersHeader-module__secondary-border-r___VYQX4 {
  border-right: 1px solid #637768;
}

.CGMFiltersHeader-module__gap-0___bRurr {
  gap: 0 !important;
}

.CGMFiltersHeader-module__gap-2___E3S9N {
  gap: 2px !important;
}

.CGMFiltersHeader-module__gap-4___H5Weo {
  gap: 4px !important;
}

.CGMFiltersHeader-module__gap-5___o2PIO {
  gap: 5px !important;
}

.CGMFiltersHeader-module__gap-6___HdeW3 {
  gap: 6px !important;
}

.CGMFiltersHeader-module__gap-8___bCTLn {
  gap: 8px !important;
}

.CGMFiltersHeader-module__gap-10___SoJ3e {
  gap: 10px !important;
}

.CGMFiltersHeader-module__gap-12___xKOyS {
  gap: 12px !important;
}

.CGMFiltersHeader-module__gap-14___ZfNUg {
  gap: 14px !important;
}

.CGMFiltersHeader-module__gap-16___vzGUG {
  gap: 16px !important;
}

.CGMFiltersHeader-module__gap-18___jN0t8 {
  gap: 18px !important;
}

.CGMFiltersHeader-module__gap-20___thXtt {
  gap: 20px !important;
}

.CGMFiltersHeader-module__gap-24___zcLa3 {
  gap: 24px !important;
}

.CGMFiltersHeader-module__gap-26___KpeXR {
  gap: 26px !important;
}

.CGMFiltersHeader-module__gap-30___biOZE {
  gap: 30px !important;
}

.CGMFiltersHeader-module__gap-32___uK1Oc {
  gap: 32px !important;
}

.CGMFiltersHeader-module__gap-40___MRxMv {
  gap: 40px !important;
}

.CGMFiltersHeader-module__gap-50___em0zS {
  gap: 50px !important;
}

.CGMFiltersHeader-module__flex-1___hOS95 {
  flex: 1;
}

.CGMFiltersHeader-module__flex-none____DkKX {
  flex: none !important;
}

.CGMFiltersHeader-module__flex-column___mma3Q {
  display: flex;
  flex-direction: column !important;
}

.CGMFiltersHeader-module__flex-row___pwima {
  display: flex;
  flex-direction: row !important;
}

.CGMFiltersHeader-module__vertically-centered___LHwbV {
  display: flex;
  align-items: center !important;
}

.CGMFiltersHeader-module__horizontally-centered___HqavA {
  display: flex;
  justify-content: center !important;
}

.CGMFiltersHeader-module__horizontally-end___vijuh {
  display: flex;
  justify-content: end !important;
}

.CGMFiltersHeader-module__vertically-start___RbdS4 {
  display: flex;
  align-items: start !important;
}

.CGMFiltersHeader-module__space-between___hV5kX {
  display: flex;
  justify-content: space-between !important;
}

.CGMFiltersHeader-module__flex-wrap___qcFQr {
  flex-wrap: wrap !important;
}

.CGMFiltersHeader-module__height-100___m5HPK {
  height: 100%;
}

.CGMFiltersHeader-module__width-50___HU5Yb {
  width: 50% !important;
}

.CGMFiltersHeader-module__width-100___jLg82 {
  width: 100%;
}

.CGMFiltersHeader-module__cursor-pointer___cIPy6 {
  cursor: pointer;
}

.CGMFiltersHeader-module__cursor-not-allowed___SbfBH {
  cursor: not-allowed !important;
}

.CGMFiltersHeader-module__absolute-centered___Cb4Cu {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMFiltersHeader-module__absolute___zNx7c {
  position: absolute;
}

.CGMFiltersHeader-module__relative___DWh4k {
  position: relative;
}

.CGMFiltersHeader-module__fixed___ca9TK {
  position: fixed;
}

.CGMFiltersHeader-module__visible___cB7dX {
  opacity: 1;
}

.CGMFiltersHeader-module__invisible___UgYNs {
  opacity: 0;
}

.CGMFiltersHeader-module__col-90____TG5n {
  width: 90% !important;
}

.CGMFiltersHeader-module__col-auto___JU7yT {
  width: auto !important;
}

.CGMFiltersHeader-module__medical-tabs___h1UJb {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMFiltersHeader-module__medical-table-new___a82KB {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMFiltersHeader-module__medical-table-new___a82KB:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMFiltersHeader-module__medical-table-new___a82KB::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMFiltersHeader-module__medical-table-new___a82KB::-webkit-scrollbar-track {
  display: none;
}
.CGMFiltersHeader-module__medical-table-new___a82KB.CGMFiltersHeader-module__no-pagination___mQA6g {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMFiltersHeader-module__medical-table-new___a82KB.CGMFiltersHeader-module__no-pagination___mQA6g:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMFiltersHeader-module__medical-table-new___a82KB.CGMFiltersHeader-module__no-pagination___mQA6g::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMFiltersHeader-module__medical-table-new___a82KB.CGMFiltersHeader-module__no-pagination___mQA6g::-webkit-scrollbar-track {
  display: none;
}

.CGMFiltersHeader-module__medical-table-empty___ec0Pz {
  padding: 14px 40px !important;
}

.CGMFiltersHeader-module__icon-btn___qzq3g {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMFiltersHeader-module__search-icon___c5Lr3 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMFiltersHeader-module__disable-select___WcEmM {
  user-select: none;
}

.CGMFiltersHeader-module__break-word___IS6xs {
  word-break: break-word;
}

.CGMFiltersHeader-module__popup-clear-btn___mdfDH {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMFiltersHeader-module__scroll-m-b-20___AuSah {
  scroll-margin-bottom: 20px;
}

.CGMFiltersHeader-module__container___ae_EP {
  width: 95%;
  justify-content: space-between;
}
.CGMFiltersHeader-module__container___ae_EP .CGMFiltersHeader-module__filters___rl4jR {
  display: grid;
  column-gap: 10px;
  grid-template-columns: 370px 260px 230px;
}
.CGMFiltersHeader-module__container___ae_EP .CGMFiltersHeader-module__filters___rl4jR .CGMFiltersHeader-module__date___QlcmR {
  padding: 3.5px 10px;
}
.CGMFiltersHeader-module__container___ae_EP .CGMFiltersHeader-module__filters___rl4jR .CGMFiltersHeader-module__select___lbgFE > div:first-child {
  padding: 4.5px !important;
}
.CGMFiltersHeader-module__container___ae_EP .CGMFiltersHeader-module__text___lbiZO {
  color: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #f1bf72;
  align-self: flex-start;
  border-radius: 17px;
  line-height: 150%;
  padding: 2px 8px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/headers/CGMFiltersHeader/CGMFiltersHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,UAAA;EACA,8BAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,gBAAA;EACA,wCAAA;AA8pBJ;AA5pBI;EACE,mBAAA;AA8pBN;AA1pBM;EACE,yBAAA;AA4pBR;AAvpBE;EACE,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAypBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  width: 95%;\n  justify-content: space-between;\n\n  .filters {\n    display: grid;\n    column-gap: 10px;\n    grid-template-columns: 370px 260px 230px;\n\n    .date {\n      padding: 3.5px 10px;\n    }\n\n    .select {\n      & > div:first-child {\n        padding: 4.5px !important;\n      }\n    }\n  }\n\n  .text {\n    color: get-color(white);\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    background-color: get-color(orangeNew, base);\n    align-self: flex-start;\n    border-radius: 17px;\n    line-height: 150%;\n    padding: 2px 8px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMFiltersHeader-module__font-s-10___M10k1`,
	"fontS12": `CGMFiltersHeader-module__font-s-12___X5Qnc`,
	"fontS13": `CGMFiltersHeader-module__font-s-13___o4s9u`,
	"fontS14": `CGMFiltersHeader-module__font-s-14___CK7fe`,
	"fontS15": `CGMFiltersHeader-module__font-s-15___m9Dbt`,
	"fontS16": `CGMFiltersHeader-module__font-s-16___kL7Sl`,
	"fontS18": `CGMFiltersHeader-module__font-s-18___KLXE6`,
	"fontS20": `CGMFiltersHeader-module__font-s-20___UA85s`,
	"fontS22": `CGMFiltersHeader-module__font-s-22___Zjf1L`,
	"fontS28": `CGMFiltersHeader-module__font-s-28___v7FLt`,
	"fontW400": `CGMFiltersHeader-module__font-w-400___C1M5r`,
	"fontW500": `CGMFiltersHeader-module__font-w-500___Q9RdV`,
	"fontW600": `CGMFiltersHeader-module__font-w-600___oCl83`,
	"fontW700": `CGMFiltersHeader-module__font-w-700___W5Dmx`,
	"p5": `CGMFiltersHeader-module__p-5___SXQJC`,
	"p12": `CGMFiltersHeader-module__p-12___Af8QT`,
	"p16": `CGMFiltersHeader-module__p-16___zzxAu`,
	"p30": `CGMFiltersHeader-module__p-30___iq95j`,
	"pB0": `CGMFiltersHeader-module__p-b-0___Dda6_`,
	"pB5": `CGMFiltersHeader-module__p-b-5____hz_n`,
	"pB10": `CGMFiltersHeader-module__p-b-10___QAGiD`,
	"pB12": `CGMFiltersHeader-module__p-b-12___icjoo`,
	"pB16": `CGMFiltersHeader-module__p-b-16___ytq44`,
	"pB18": `CGMFiltersHeader-module__p-b-18___R_nhN`,
	"pB20": `CGMFiltersHeader-module__p-b-20___E7b68`,
	"pB25": `CGMFiltersHeader-module__p-b-25___vsYnd`,
	"pB30": `CGMFiltersHeader-module__p-b-30___VEcfO`,
	"pB50": `CGMFiltersHeader-module__p-b-50___fFTBq`,
	"pT0": `CGMFiltersHeader-module__p-t-0___mA21f`,
	"pT12": `CGMFiltersHeader-module__p-t-12___QyOdS`,
	"pT16": `CGMFiltersHeader-module__p-t-16___q0ian`,
	"pT18": `CGMFiltersHeader-module__p-t-18___VeYnp`,
	"pT20": `CGMFiltersHeader-module__p-t-20___LEsf4`,
	"pT30": `CGMFiltersHeader-module__p-t-30___eAHGV`,
	"pT40": `CGMFiltersHeader-module__p-t-40___SbmRY`,
	"pT50": `CGMFiltersHeader-module__p-t-50___wfkYx`,
	"pL20": `CGMFiltersHeader-module__p-l-20___cx7pa`,
	"pL30": `CGMFiltersHeader-module__p-l-30___piVK0`,
	"pL40": `CGMFiltersHeader-module__p-l-40___R7Xse`,
	"pR16": `CGMFiltersHeader-module__p-r-16___rknlF`,
	"pR20": `CGMFiltersHeader-module__p-r-20___FWOww`,
	"pR30": `CGMFiltersHeader-module__p-r-30___Z3raj`,
	"pR50": `CGMFiltersHeader-module__p-r-50___a_AF4`,
	"pR60": `CGMFiltersHeader-module__p-r-60___B_XIp`,
	"mB1": `CGMFiltersHeader-module__m-b-1___PC3T8`,
	"mB2": `CGMFiltersHeader-module__m-b-2___o6GIQ`,
	"mB6": `CGMFiltersHeader-module__m-b-6___BTEvW`,
	"mB8": `CGMFiltersHeader-module__m-b-8___VYOmk`,
	"mB10": `CGMFiltersHeader-module__m-b-10___z6uu2`,
	"mB14": `CGMFiltersHeader-module__m-b-14___k0Cz0`,
	"mB16": `CGMFiltersHeader-module__m-b-16___bNmkN`,
	"mB20": `CGMFiltersHeader-module__m-b-20____GsRc`,
	"mB22": `CGMFiltersHeader-module__m-b-22___ctpkE`,
	"mB24": `CGMFiltersHeader-module__m-b-24___hMeKW`,
	"mB30": `CGMFiltersHeader-module__m-b-30___ONZ8D`,
	"mB32": `CGMFiltersHeader-module__m-b-32___EcbuU`,
	"mB40": `CGMFiltersHeader-module__m-b-40____miR2`,
	"mT2": `CGMFiltersHeader-module__m-t-2___vzpUi`,
	"mT3": `CGMFiltersHeader-module__m-t-3___Fdoct`,
	"mT4": `CGMFiltersHeader-module__m-t-4___c3VIz`,
	"mT5": `CGMFiltersHeader-module__m-t-5___XYoH0`,
	"mT8": `CGMFiltersHeader-module__m-t-8___XLiu0`,
	"mT10": `CGMFiltersHeader-module__m-t-10___IMq87`,
	"mT15": `CGMFiltersHeader-module__m-t-15___X0Cfs`,
	"mT16": `CGMFiltersHeader-module__m-t-16___qlOzG`,
	"mT20": `CGMFiltersHeader-module__m-t-20___iqJ4g`,
	"mT22": `CGMFiltersHeader-module__m-t-22___Scsx_`,
	"mT30": `CGMFiltersHeader-module__m-t-30___oG2x0`,
	"mT32": `CGMFiltersHeader-module__m-t-32___olsJr`,
	"mLAuto": `CGMFiltersHeader-module__m-l-auto___Lwp5A`,
	"mL4": `CGMFiltersHeader-module__m-l-4___y5geV`,
	"mL5": `CGMFiltersHeader-module__m-l-5___wrznR`,
	"mL6": `CGMFiltersHeader-module__m-l-6___X5UYr`,
	"mL8": `CGMFiltersHeader-module__m-l-8___QcYU3`,
	"mL10": `CGMFiltersHeader-module__m-l-10___WMZDd`,
	"mL16": `CGMFiltersHeader-module__m-l-16___eUSyn`,
	"mL20": `CGMFiltersHeader-module__m-l-20___jARj0`,
	"mL24": `CGMFiltersHeader-module__m-l-24___E9e2h`,
	"mL30": `CGMFiltersHeader-module__m-l-30___wolvo`,
	"mL35": `CGMFiltersHeader-module__m-l-35___uqnXB`,
	"mL40": `CGMFiltersHeader-module__m-l-40___pnX5L`,
	"mR8": `CGMFiltersHeader-module__m-r-8___GZxUG`,
	"mR10": `CGMFiltersHeader-module__m-r-10___Invz4`,
	"mR16": `CGMFiltersHeader-module__m-r-16___XBqcX`,
	"mR20": `CGMFiltersHeader-module__m-r-20___prt6Q`,
	"mR24": `CGMFiltersHeader-module__m-r-24___zsRSl`,
	"mR30": `CGMFiltersHeader-module__m-r-30___YKnep`,
	"mR40": `CGMFiltersHeader-module__m-r-40___C2qFk`,
	"borderR3": `CGMFiltersHeader-module__border-r-3___JTH1P`,
	"borderR4": `CGMFiltersHeader-module__border-r-4___XlA6D`,
	"borderR6": `CGMFiltersHeader-module__border-r-6___MRXMt`,
	"borderR10": `CGMFiltersHeader-module__border-r-10___tNNm2`,
	"borderR12": `CGMFiltersHeader-module__border-r-12___BoM2q`,
	"borderR16": `CGMFiltersHeader-module__border-r-16___cggux`,
	"borderR50": `CGMFiltersHeader-module__border-r-50___pmeE2`,
	"primaryBorder": `CGMFiltersHeader-module__primary-border___yRhi3`,
	"primaryBorderB": `CGMFiltersHeader-module__primary-border-b___bt_te`,
	"primaryBorderT": `CGMFiltersHeader-module__primary-border-t___VFQfw`,
	"primaryBorderL": `CGMFiltersHeader-module__primary-border-l___V4eM2`,
	"primaryBorderR": `CGMFiltersHeader-module__primary-border-r___kdkNS`,
	"secondaryBorder": `CGMFiltersHeader-module__secondary-border___bGNkZ`,
	"secondaryBorderB": `CGMFiltersHeader-module__secondary-border-b___cLvzm`,
	"secondaryBorderT": `CGMFiltersHeader-module__secondary-border-t___f5K84`,
	"secondaryBorderL": `CGMFiltersHeader-module__secondary-border-l___bFL0V`,
	"secondaryBorderR": `CGMFiltersHeader-module__secondary-border-r___VYQX4`,
	"gap0": `CGMFiltersHeader-module__gap-0___bRurr`,
	"gap2": `CGMFiltersHeader-module__gap-2___E3S9N`,
	"gap4": `CGMFiltersHeader-module__gap-4___H5Weo`,
	"gap5": `CGMFiltersHeader-module__gap-5___o2PIO`,
	"gap6": `CGMFiltersHeader-module__gap-6___HdeW3`,
	"gap8": `CGMFiltersHeader-module__gap-8___bCTLn`,
	"gap10": `CGMFiltersHeader-module__gap-10___SoJ3e`,
	"gap12": `CGMFiltersHeader-module__gap-12___xKOyS`,
	"gap14": `CGMFiltersHeader-module__gap-14___ZfNUg`,
	"gap16": `CGMFiltersHeader-module__gap-16___vzGUG`,
	"gap18": `CGMFiltersHeader-module__gap-18___jN0t8`,
	"gap20": `CGMFiltersHeader-module__gap-20___thXtt`,
	"gap24": `CGMFiltersHeader-module__gap-24___zcLa3`,
	"gap26": `CGMFiltersHeader-module__gap-26___KpeXR`,
	"gap30": `CGMFiltersHeader-module__gap-30___biOZE`,
	"gap32": `CGMFiltersHeader-module__gap-32___uK1Oc`,
	"gap40": `CGMFiltersHeader-module__gap-40___MRxMv`,
	"gap50": `CGMFiltersHeader-module__gap-50___em0zS`,
	"flex1": `CGMFiltersHeader-module__flex-1___hOS95`,
	"flexNone": `CGMFiltersHeader-module__flex-none____DkKX`,
	"flexColumn": `CGMFiltersHeader-module__flex-column___mma3Q`,
	"flexRow": `CGMFiltersHeader-module__flex-row___pwima`,
	"verticallyCentered": `CGMFiltersHeader-module__vertically-centered___LHwbV`,
	"horizontallyCentered": `CGMFiltersHeader-module__horizontally-centered___HqavA`,
	"horizontallyEnd": `CGMFiltersHeader-module__horizontally-end___vijuh`,
	"verticallyStart": `CGMFiltersHeader-module__vertically-start___RbdS4`,
	"spaceBetween": `CGMFiltersHeader-module__space-between___hV5kX`,
	"flexWrap": `CGMFiltersHeader-module__flex-wrap___qcFQr`,
	"height100": `CGMFiltersHeader-module__height-100___m5HPK`,
	"width50": `CGMFiltersHeader-module__width-50___HU5Yb`,
	"width100": `CGMFiltersHeader-module__width-100___jLg82`,
	"cursorPointer": `CGMFiltersHeader-module__cursor-pointer___cIPy6`,
	"cursorNotAllowed": `CGMFiltersHeader-module__cursor-not-allowed___SbfBH`,
	"absoluteCentered": `CGMFiltersHeader-module__absolute-centered___Cb4Cu`,
	"absolute": `CGMFiltersHeader-module__absolute___zNx7c`,
	"relative": `CGMFiltersHeader-module__relative___DWh4k`,
	"fixed": `CGMFiltersHeader-module__fixed___ca9TK`,
	"visible": `CGMFiltersHeader-module__visible___cB7dX`,
	"invisible": `CGMFiltersHeader-module__invisible___UgYNs`,
	"col90": `CGMFiltersHeader-module__col-90____TG5n`,
	"colAuto": `CGMFiltersHeader-module__col-auto___JU7yT`,
	"medicalTabs": `CGMFiltersHeader-module__medical-tabs___h1UJb`,
	"medicalTableNew": `CGMFiltersHeader-module__medical-table-new___a82KB`,
	"noPagination": `CGMFiltersHeader-module__no-pagination___mQA6g`,
	"medicalTableEmpty": `CGMFiltersHeader-module__medical-table-empty___ec0Pz`,
	"iconBtn": `CGMFiltersHeader-module__icon-btn___qzq3g`,
	"searchIcon": `CGMFiltersHeader-module__search-icon___c5Lr3`,
	"disableSelect": `CGMFiltersHeader-module__disable-select___WcEmM`,
	"breakWord": `CGMFiltersHeader-module__break-word___IS6xs`,
	"popupClearBtn": `CGMFiltersHeader-module__popup-clear-btn___mdfDH`,
	"scrollMB20": `CGMFiltersHeader-module__scroll-m-b-20___AuSah`,
	"container": `CGMFiltersHeader-module__container___ae_EP`,
	"filters": `CGMFiltersHeader-module__filters___rl4jR`,
	"date": `CGMFiltersHeader-module__date___QlcmR`,
	"select": `CGMFiltersHeader-module__select___lbgFE`,
	"text": `CGMFiltersHeader-module__text___lbiZO`
};
module.exports = ___CSS_LOADER_EXPORT___;
